// Query-key factory for the org-template cache, including the two
// presigned-PDF-URL roots that deliberately live OUTSIDE the
// ['orgTemplates', ...] subtree (they carry a 30-minute staleTime that a
// template-detail invalidation must not reset — only PDF mutations drop
// them). Centralising the shapes keeps mutation invalidations and query
// keys from drifting apart.
//
// Keys are runtime-identical to the inline arrays they replaced.
//
// Leaf module: admin tests vi.mock the hook modules with explicit
// factories and must not need to stub key builders.

export const orgTemplateKeys = {
  all: ["orgTemplates"] as const,

  list: (params?: { limit?: number }) => ["orgTemplates", params] as const,

  detail: (id: string) => ["orgTemplates", id] as const,

  versions: (id: string) => ["orgTemplates", id, "versions"] as const,

  /** Prefix matching every module-PDF URL query for a template. */
  modulePdfRoot: (templateId: string) =>
    ["orgTemplate-module-pdf", templateId] as const,

  modulePdf: (templateId: string, moduleId: string | null) =>
    ["orgTemplate-module-pdf", templateId, moduleId] as const,

  contractDetailsPdf: (templateId: string) =>
    ["orgTemplate-contract-details-pdf", templateId] as const,
};
